const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  activeMesa: null,
  activeSession: null,
};

const slice = createSlice({
  name: "active",
  initialState,
  reducers: {
    setActiveMesa: (state, action) => {
      state.activeMesa = action.payload;
    },
    setActiveSession: (state, action) => {
      state.activeSession = action.payload;
    },
  },
});

export default slice.reducer;

export const { setActiveMesa, setActiveSession } = slice.actions;
